import tiktokAuth from './auth-integrations/tiktok-auth'
import googleAdsAuth from './auth-integrations/google-ads-auth'
import googleAdsLeadFormAuth from './auth-integrations/ads-lead-form-auth'

export default [
    tiktokAuth,
    googleAdsAuth,
    googleAdsLeadFormAuth
]
